export enum Shopability {
  Shoppable,
  ShoppingComplete,
  Inaccessible,
}